<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
	<span class="">
    <div class="logo-mini gradiente">
		  <a href="/"><img src="/static/img/logo.png" alt="PowerSuppliers" class="left-block logo"></a>
    </div>
	</span>
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <!-- <a href="javascript:;" class="sidebar-toggle pull-right" data-toggle="offcanvas" role="button">
          <span class="sr-only pull-left">Toggle navigation</span>
        </a> -->
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu" v-if="user">
          <ul class="nav navbar-nav">
            <!-- Messages-->
            <!--<el-tooltip class="" v-if="!user.isProvider" effect="dark" content="Documentación recibida" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link :to="{'name': 'Búsqueda', params: { statusId: ['4'] }}" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="el-icon-document"></i>
                  <span class="label label-success" v-if="newInvoices.length > 0">{{ newInvoices.length }}</span>
                </router-link>
              </li>
            </el-tooltip> -->
            <el-tooltip class="" v-if="!user.isProvider && false" effect="dark" content="Usuarios por activar" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link to="/contacts" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="	fas fa-user-plus"></i>
                  <span class="label label-success" v-if="newContacts.length > 0">{{ newContacts.length }}</span>
                </router-link>
              </li>
            </el-tooltip>
            <el-tooltip class="" v-if="!user.isProvider && false" effect="dark" content="Mensajes nuevos" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link to="/allComments" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-envelope"></i>
                  <span class="label label-success" v-if="receivedNew.length > 0">{{ receivedNew.length }}</span>
                </router-link>
              </li>
            </el-tooltip>
            <!--
            <el-tooltip class="" v-if="user.isProvider" effect="dark" content="Ordenes de compra" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link :to="{'name': 'Búsqueda', params: { statusId: ['2', '3'] }}" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="el-icon-document"></i>
                  <span class="label label-success" v-if="newBuyOrders.length > 0">{{ newBuyOrders.length }}</span>
                </router-link>
              </li>
            </el-tooltip> -->
            <!--
            <el-tooltip class="" v-if="user.isProvider" effect="dark" content="Documentos devueltos" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link :to="{'name': 'Búsqueda', params: { statusId: ['8'] }}" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="fas fa-reply"></i>
                  <span class="label label-success" v-if="documentosDevueltos.length > 0">{{ documentosDevueltos.length }}</span>
                </router-link>
              </li>
            </el-tooltip>
            -->
            <el-tooltip class="" v-if="user.isProvider && false" effect="dark" content="Pagos" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link :to="{'name': 'Búsqueda', params: { statusId: ['6']}}" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="el-icon-tickets"></i>
                  <span class="label label-success" v-if="newPayments.length > 0">{{ newPayments.length }}</span>
                </router-link>
              </li>
            </el-tooltip>
            <el-tooltip class="" v-if="user.isProvider && false" effect="dark" content="Mensajes nuevos" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link to="/allComments" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-comment"></i>
                  <span class="label label-success" v-if="providerNewMessages.length > 0">{{ providerNewMessages.length }}</span>
                </router-link>
              </li>
            </el-tooltip>
            <el-tooltip class="" v-if="user.isProvider && false" effect="dark" content="Invitaciones a compulsas" placement="bottom">
              <li class="dropdown messages-menu">
                <router-link to="/compulsas" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-envelope"></i>
                  <span class="label label-success" v-if="newCompulsas.length > 0">{{ newCompulsas.length }}</span>
                </router-link>
              </li>
            </el-tooltip>
            <!-- /.messages-menu -->

            <li class="dropdown user user-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <!-- The user image in the navbar-->
                <!--<img :src="user.avatar" class="user-image" alt="User Image"> -->
                <!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="dashUsername">{{ user.name }}</span>
              </a>
              <!-- Account Info and Menu -->
              <ul class="dropdown-menu">
                <li class="user-header" style="height:auto;min-height:85px;padding-bottom:15px;">
                  <p>
                    <span>{{ user.name }}</span>
                   <small> Puesto: {{ user.job.job }}</small>
                    <small> {{ user.email }}</small>
                  </p>
                </li>
                <li class="user-footer">
                    <router-link tag="li" class="pageLink" to="" @click.native="logout" v-if="user">
                      <div style="text-align: center">
                      <a>
                        <i class="fa fa-sign-out-alt text-red"></i>
                        <span class="page" style="color:var(--primary-color)">Cerrar Sesión</span>
                      </a>
                      </div>
                    </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="fa fa-home" data-cy="home"></i>Home</router-link>
          </li>
          <li class="active">{{$route.name.toUpperCase()}}</li>
        </ol>
      </section>

      <router-view v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Cargando información, aguarde un momento"></router-view>
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer text-center">
      <div v-if="entorno" class="entorno">{{entorno}}</div>
      <strong>Copyright &copy; {{year}}
        <a href="javascript:;"> </a>.</strong> powered by PowerSuppliers.io
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import api from '../api'
import axios from 'axios'

export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      entorno: '',
      year: new Date().getFullYear(),
      // entorno: '',
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: '',
      enviados: [],
      recibidos: [],
      recibidosNew: [],
      invoices: [],
      modalUnauthorized: false,
      timmerMessage: null
    }
  },
  computed: {
    ...mapState([
      'userInfo', 'user'
    ]),
    receivedNew () {
      if (this.$store.state.messages.length > 0) {
        return this.$store.state.provMessages.filter(el => el.messages !== undefined && el.messages.find(msg => msg.status === '0' && msg.idReceptor === '0'))
      } else {
        return []
      }
    },
    providerNewMessages () {
      if (this.$store.state.messages.length > 0) {
        return this.$store.state.messages.filter(el => el.idReceptor === this.idUser && el.status === '0')
      } else {
        return []
      }
    },
    /*
    newBuyOrders () {
      if (this.user.isProvider) {
        return this.$store.state.ordenesCompra.filter(el => el.view === '0' && (el.statusId === '2' || el.statusId === '3'))
      } else {
        return this.$store.state.ordenesCompra.filter(el => el.view === '0' && el.statusId === '1')
      }
    },
    documentosDevueltos () {
      return this.$store.state.ordenesCompra.filter(el => el.view === '0' && el.statusId === '8')
    },
    newInvoices () {
      return this.$store.state.ordenesCompra.filter(el => el.view === '0' && el.statusId === '4')
    },
    */
    newPayments () {
      return this.$store.state.ordenesCompra.filter(el => el.view === '0' && el.statusId === '6')
    },

    newContacts () {
      if (this.$store.state.contacts.length > 0) {
        return this.$store.state.contacts.filter(el => el.idProviderStatus === '1')
      } else {
        return []
      }
    },
    newCompulsas () {
      if (this.$store.state.compulsas.length > 0 && this.user.isProvider) {
        return this.$store.state.compulsas.filter(el => el.visto === '0')
      }
      return []
    },
    idUser () {
      if (this.user) {
        return this.user.idUser
      }
      return false
    },
    fullscreenLoading () {
      return this.$store.state.apiCalls > 0
    }
  },
  methods: {
    getEntorno () {
      api.request('get', 'api/findConfiguration/ENTORNO')
      .then(response => {
        this.entorno = response.data['value']
      })
      .catch(error => {
        console.log(error)
      })
    },
    getFrontendModulesAndRolesHasModules () {
      api.request('GET', 'api/generic/frontendModules')
      .then(response => {
        this.$store.commit('SET_FRONTENDMODULES', response.data)
      })
      api.request('GET', 'api/generic/rolesHasModules')
      .then(response => {
        this.$store.commit('SET_ROLESHASMODULES', response.data)
      })
    },
    postLogout () {
      const data = {
        userId: this.user.idUser,
        companyId: this.user.idCompany
      }
      api.request('POST', 'api/logout', {data})
        .then(response => {
          if (response.status === 200) {
            console.log('Succesfull Logout')
            return
          } else {
            console.log('Failed to Logout user')
          }
        }).catch(error => {
          console.error(error)
        })
    },
    logoutFromError () {
      if (this.modalUnauthorized) {
        return
      }
      this.modalUnauthorized = true
      this.$alert('Se venció la sesión, por favor vuelva a iniciar sesión', 'Advertencia', {
        confirmButtonText: 'OK',
        type: 'warning',
        lockScroll: false,
        closable: false
      })
      .then(() => {
        if (this.$store.state.user) {
          this.postLogout()
          this.logoutMethods()
        }
      })
      .catch(() => {
        if (this.$store.state.user) {
          this.logoutMethods()
        }
      })
    },
    logout () {
      this.$confirm('¿Realmente desea cerrar sesión?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      })
      .then(() => {
        this.postLogout()
        this.logoutMethods()
      })
      .catch(() => {})
    },
    logoutMethods () {
      localStorage.removeItem('user')
      this.$store.commit('SET_USER', '')
      this.$store.commit('SET_TOKEN', '')
      this.$store.commit('SET_MESSAGES', '')
      this.$store.commit('RESET_STATE')
      window.localStorage.removeItem('token')
      this.$router.push('/login')
    },
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    getCompanyStage () {
      api.request('GET', 'api/generic/companyStage')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.commit('SET_COMPANYDATASTAGE', data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getBuyOrders () {
      return new Promise((resolve, reject) => {
        // let newBuyOrdersLength = this.newBuyOrders.length
        let newInvoicesLenght = this.newInvoices.length
        let newPaymentLenght = this.newPayments.length
        const {idUser} = this

        this.$store.commit('START_LOADING')
        /* Making API call to authenticate a user */
        api.request('GET', 'api/getBuyOrder/' + idUser)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          /* Setting user in the state and caching record to the localStorage */
          if (data) {
            this.$store.commit('SET_BUYORDERS', data.filter(el => el.nic !== null))
            this.$store.commit('SET_OTHEROPERATIONS', data.filter(el => el.nic === null))
            /*
            if (newBuyOrdersLength < this.newBuyOrders.length && this.user.isProvider) {
              if (this.newBuyOrders.length > 1) {
                if (this.newBuyOrders.statusId === 2) {
                  this.notify('Ha recibido ' + this.newBuyOrders.length + 'nuevas NICs  (Adjudicadas)')
                } else {
                  this.notify('Ha recibido ' + this.newBuyOrders.length + ' nuevas NICs listas a facturar')
                }
              } else {
                if (this.newBuyOrders.statusId === 2) {
                  this.notify('Tiene una nueva OC adjudicada')
                } else {
                  this.notify('Tiene una nueva NICs lista a facturar'.his.newBuyOrders.statusId)
                }
              }
            } */
            if (newInvoicesLenght < this.newInvoices.length && !this.user.isProvider) {
              if (this.newInvoices.length > 1) {
                this.notify('Ha recibido ' + this.newInvoices.length + ' nuevos documentos para verificar')
              } else {
                this.notify('Ha recibido un nuevo documento')
              }
            }
            if (newPaymentLenght < this.newPayments.length && this.user.isProvider) {
              if (this.newPayments.length > 1) {
                this.notify('Ha recibido ' + this.newPayments.length + ' nuevas ordenes de pagos')
              } else {
                this.notify('Ha recibido ' + this.newPayments.length + ' nueva orden de pago')
              }
            }
            this.$store.commit('STOP_LOADING')
            resolve(data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
          this.$store.commit('STOP_LOADING')
          reject(error)
        })
      })
    },
    getBuyOrderStatus () {
      /* Making API call to authenticate a user */
      api.request('GET', 'api/generic/buyOrderStatus?idUser=' + this.idUser)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data) {
            this.$store.commit('SET_BUYORDERSTATUS', data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getCompanyDataStatus () {
      /* Making API call to authenticate a user */
      api.request('GET', 'api/generic/companyDataStatus')
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data) {
            this.$store.commit('SET_COMPANYDATASTATUS', data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getBuyOrderDocumentStatus () {
      /* Making API call to authenticate a user */
      api.request('GET', 'api/generic/buyOrderDocumentStatus')
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data) {
            data.forEach(stat => {
              stat.description = this.user.isProvider ? stat.descriptionProvider : stat.descriptionBackend
            })
            this.$store.commit('SET_BUYORDERDOCUMENTSTATUS', data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getAllBuyOrderStatus () {
      /* Making API call to authenticate a user */
      api.request('GET', 'api/generic/buyOrderStatus')
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data) {
            this.$store.state.countStatus = data
            this.$store.commit('SET_BUYORDERSTATUS', data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getContacts () {
      this.$store.commit('START_LOADING')
      api.request('GET', 'api/generic/provider')
        .then(response => {
          let newContactsLength = this.newContacts.length
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            this.$store.commit('SET_CONTACTS', data)
            if (newContactsLength < this.newContacts.length && !this.user.isProvider) {
              /*
                if (this.newContacts.length > 1) {
                  this.notify(this.newContacts.length + ' Usuarios por activar')
                } else {
                  this.notify(this.newContacts.length + ' Usuario por activar')
                }
              */
            }
          }
          this.$store.commit('STOP_LOADING')
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.$store.commit('STOP_LOADING')
          console.log(error)
        })
    },
    getBuyOrderDocumentType () {
      api.request('GET', 'api/generic/buyOrderDocumentType')
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            this.$store.commit('SET_BUYORDERDOCUMENTTYPE', data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    /* getProviders () {
      // We need to pass the component's this context
      // to properly make use of http in the auth service
      let limit = 500
      this.$store.commit('START_LOADING')
      api.request('GET', 'api/generic/company')
      .then(response => {
        var data = response.data
        if (data.error) {
          return
        }
        if (data) {
          let provs = data
          provs.forEach((el, index) => {
            el.calification = parseInt(el.calification)
          })
        }
      })
      this.$store.commit('STOP_LOADING')
    }, */
    getLicitaciones () {
      return new Promise((resolve, reject) => {
        let compulsasLenght = this.newCompulsas.length
        this.$store.commit('START_LOADING')
        api.request('GET', 'api/getLicitaciones?id=' + this.user.idUser)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            this.$store.commit('SET_COMPULSAS', data)
            if (compulsasLenght < this.newCompulsas.length) {
              if (this.newCompulsas.length > 1) {
                this.notify('Has sido invitado a ' + this.newCompulsas.length + ' compulsas')
              } else {
                this.notify('Has sido invitado a ' + this.newCompulsas.length + ' compulsa')
              }
            }
            this.$store.commit('STOP_LOADING')
            resolve(data)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
          this.$store.commit('STOP_LOADING')
          reject(error)
        })
      })
    },
    notify (notificationMessage) {
      this.$notify({
        title: '',
        type: 'warning',
        message: notificationMessage,
        duration: 20000,
        showClose: true,
        offset: 50
      })
    },
    checkComments (currentPage = 1, pageSize = 20, searchQuery = '') {
      return new Promise((resolve, reject) => {
        //  let providerMessagesLength = this.providerNewMessages.length
        //  let userMessagesLength = this.receivedNew.length

        if (!this.$store.state.user) {
          return
        }
        // We need to pass the component's this context
        // to properly make use of http in the auth service
        if (this.idUser) {
          api.request('GET', 'api/getMessages/messages/' + this.idUser + '?pageSize=' + pageSize + '&currentPage=' + currentPage + '&searchQuery=' + searchQuery)
          .then(response => {
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.error) {
              return
            }

            /* Setting user in the state and caching record to the localStorage */
            if (data.messages) {
              this.$store.commit('SET_MESSAGES', data.messages)
              /*
                if (providerMessagesLength < this.providerNewMessages.length && this.user.isProvider) {
                  if (this.providerNewMessages.length > 1) {
                    this.notify(this.providerNewMessages.length + ' mensajes nuevos')
                  } else {
                    this.notify(this.providerNewMessages.length + ' mensaje nuevo')
                  }
                }
              */
            }
            if (data.provMessages) {
              // this.recibidosNew = []
              this.$store.commit('SET_PROVMESSAGES', data.provMessages)
              if (this.recievedNew !== undefined) {
                /*
                  if (userMessagesLength < this.recievedNew.length && !this.user.isProvider) {
                    if (this.receivedNew.length > 1) {
                      this.notify(this.recievedNew.length + ' mensajes nuevos')
                    } else {
                      this.notify(this.recievedNew.length + ' mensaje nuevo')
                    }
                  }
                */
              }
              /* for (var j = 0; j < this.$store.state.provMessages.length; j++) {
                if (this.$store.state.provMessages[j].messages && this.$store.state.provMessages[j].messages.filter(el => el.status === '0' && el.idReceptor === '0').length > 0) {
                  this.recibidosNew.push(this.$store.state.provMessages[j])
                }
              }
              if (this.recibidosNew.length > 0) {
                this.$store.commit('SET_RECEIVEDNEW', this.recibidosNew)
              } */
            }
            // this.$store.commit('STOP_LOADING')
            resolve()
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
            // this.$store.commit('STOP_LOADING')
            reject(error)
          })
        }
      })
    },
    getCountries () {
      api.request('GET', 'api/generic/country')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.countries = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getGroupCompanies () {
      api.request('GET', 'api/generic/groupCompanies')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.groupCompanies = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getNews () {
      api.request('GET', 'api/generic/news')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.news = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getProvinces () {
      api.request('GET', 'api/generic/province')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.provinces = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getServices () {
      api.request('GET', 'api/generic/rubros')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.services = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRetentionCategories () {
      api.request('GET', 'api/generic/categoryRetain')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.retentionCategories = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRetentionCategoriesVAT () {
      api.request('GET', 'api/generic/categoryRetainVAT')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.retentionCategoriesVAT = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRetentionCategoriesOTROS () {
      api.request('GET', 'api/generic/categoryRetainOTROS')
        .then(response => {
          var data = response.data.filter((category) => category.codCountry === 'AR')
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.retentionCategoriesOTROS = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getSussRetentionCategories () {
      api.request('GET', 'api/generic/sussCategoryRetain')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.sussRetentionCategory = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getIbRetentionCategories () {
      api.request('GET', 'api/generic/ibCategoryRetain')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.ibRetentionCategory = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRegimenTypes () {
      api.request('GET', 'api/generic/agreementRegimeType')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.regimenTypes = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRetentionRegimes () {
      api.request('GET', 'api/generic/retentionRegime')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.retentionRegimes = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRetentionRegimesVAT () {
      api.request('GET', 'api/generic/retentionRegimeVAT')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.retentionRegimesVAT = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRetentionRegimesOTROS () {
      api.request('GET', 'api/generic/retentionRegimeOTROS')
        .then(response => {
          var data = response.data.filter((regime) => regime.codCountry === 'AR')
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.retentionRegimesOTROS = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getJurisdictions () {
      api.request('GET', 'api/generic/jurisdictions')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.jurisdictions = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getBanks () {
      api.request('GET', 'api/generic/bank')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.banks = data.filter((bank) => bank.codCountry === 'AR')
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getBankBranchs () {
      api.request('GET', 'api/generic/bankBranch')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.bankBranches = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getBankAccountTypes () {
      api.request('GET', 'api/generic/bankAccountType')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.$store.state.accountTypes = data.filter((bankAccountType) => bankAccountType.codCountry === 'AR')
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getInformation () {
      this.getEntorno()
      if (this.$store.state.user) {
        this.getFrontendModulesAndRolesHasModules()
        // this.getBuyOrders()
        this.checkComments()
        this.getBuyOrderStatus()
        this.getAllBuyOrderStatus()
        this.getCompanyDataStatus()
        this.getContacts()
        // this.getProviders()
        this.getLicitaciones()
        this.getBuyOrderDocumentType()
        this.getBuyOrderDocumentStatus()
        this.getCompanyStage()
      }
      this.getCountries()
      this.getGroupCompanies()
      this.getNews()
      this.getProvinces()
      this.getServices()
      this.getRetentionCategories()
      this.getRetentionCategoriesVAT()
      this.getRetentionCategoriesOTROS()
      this.getSussRetentionCategories()
      this.getIbRetentionCategories()
      this.getRegimenTypes()
      this.getRetentionRegimes()
      this.getRetentionRegimesVAT()
      this.getRetentionRegimesOTROS()
      this.getJurisdictions()
      this.getBanks()
      this.getBankBranchs()
      this.getBankAccountTypes()
    },
    refreshToken () {
      let token = window.localStorage.getItem('token')
      if (token) {
        api.request('GET', 'api/refreshToken')
        .then(response => {
          if (response.data.token) {
            window.localStorage.setItem('token', response.data.token)
          }
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  },
  mounted () {
    if (this.idUser) {
      this.modalUnauthorized = false
      const UNAUTHORIZED = 401
      axios.interceptors.response.use(
        response => response,
        error => {
          const status = error.response ? error.response.status : null
          if (this.idUser && status === UNAUTHORIZED) {
            this.logoutFromError()
          }
          return Promise.reject(error)
        }
      )
      this.getInformation()
      // setInterval(() => this.refreshToken(), 1000 * 20)
      this.checkComments()
      setInterval(() => this.getInformation(), 1000 * 60 * 15)
    } else {
      this.getInformation()
    }
  },
  beforeMount () {
    const UNAUTHORIZED = 401
    axios.interceptors.response.use(
      response => response,
      error => {
        const {status} = JSON.stringify(error)
        if (this.idUser && status === UNAUTHORIZED) {
          this.logoutFromError()
        }
        return Promise.reject(error)
      }
    )
  },
  beforeDestroy () {
    clearInterval(this.timmerMessage)
  }
}
</script>

<style lang="scss">
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
    min-height: 90%;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
  background-color : #ffffff;
  img {
    padding: .0em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.pull-right {
    float: right;
}

.pull-left {
    float: left;
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.navegacion{
  background-color: #888888;
}

.gradiente {
  background-color:  #56565A;
}
.entorno {
    position: fixed;
    top: 93%;
    left: 85%;
    transform: translate(-50%, -50%);
    background-color: rgba(255, 255, 255, 0.7);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    text-align: center;
    color: blue;
    z-index: 1;
  }

</style>



// WEBPACK FOOTER //
// Dash.vue?40dec876